module.exports = __webpack_public_path__ + "img/added-service-unit-02.b3c9b37f.png";